<template>
  <div v-if="isUserAdmin">

    <div class="">
      <div class="overflow-hidden">
        <div class="float-left text-2xl">
          Planners
        </div>

        <div class="float-right ml-4">
          <a href="#"
            v-on:click.prevent="exportAsCsv()"
            class="text-white uppercase bg-blue-500 font-semibold inline-block no-underline hover:bg-blue-600 text-xs p-2">Export as a CSV</a>
        </div>
      </div>
    </div>

    <PlannerList></PlannerList>
  </div>
</template>

<script>

  import axios        from "axios";
  import PlannerList   from "./PlannerList"
  import { EventBus } from '@/shared/event-bus';

  export default {

    components: {
      PlannerList,
    },

    methods: {
      exportAsCsv() {
        this.showLoader("Exporting...")
        axios.get(process.env.VUE_APP_API_URL + '/api/planner/export', {
          responseType: 'blob',
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {

           this.hideLoader();
           const url    = window.URL.createObjectURL(new Blob([response.data]));
           const link   = document.createElement('a');
           link.href    = url;
           link.setAttribute('download', 'plannerpad_planners.csv'); //or any other extension
           document.body.appendChild(link);
           link.click();

           EventBus.$emit('notification-event', {
            'type'   : 'success',
            'message': 'CSV is successfully exported!.'
          });
        })
        .catch(e => {
          this.hideLoader();
        })
      }

    }
  }
</script>
